/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-24 23:12:31
 * @LastEditTime: 2022-07-29 14:37:32
 * @LastEditors: chenguobiao
 */
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  },
}
